import * as React from 'react'
import {compose} from 'redux'
import {withI18n} from 'src/core/i18n'
import {WithI18n} from 'src/core/i18n/withI18n'
import { Field, reduxForm, formValueSelector, submit } from 'redux-form'
import { TextField } from 'redux-form-material-ui'
import Grid from '@material-ui/core/Grid/Grid'
import Actions from 'src/page/ValidationTunnel/Actions'
import {Validator} from 'src/core/form/Validator'
import {connect} from 'react-redux'
import autobind from 'autobind-decorator'
import LabelValidation from 'src/shared/LabelValidation/LabelValidation'
import {Theme, WithStyles} from '@material-ui/core'
import createStyles from '@material-ui/core/styles/createStyles'
import withStyles from '@material-ui/core/styles/withStyles'
import Btn from 'src/shared/Btn/Btn'
import {RootState} from 'src/core/redux/reducer'
import Alert from 'src/shared/Alert/Alert'

const styles = (t: Theme) => createStyles({
  helpContainer: {
    marginTop: t.spacing.unit * 3
  },
  labelsContainer:{
    marginLeft: t.spacing.unit * 3
  },
  helpContainerText: {
    marginBottom: t.spacing.unit * 2
  },

});

interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>{
  handleSubmit: () => void;
  password: string | null;
  valid:boolean;
  inTunnel: boolean;
  needReset?: boolean;
}

const validate = (values, props) => Validator.build(values, {
  ...!props.needReset && {'old_password': [Validator.required]},
  'new_password': [Validator.required,Validator.password],
  'password_confirm': [Validator.required,Validator.passwordConfim(props.password)]
});

class PasswordTunnel extends React.Component<IProps, any>{

  render(){
    const { t, classes, valid, isUpdating, inTunnel, needReset } = this.props;
    return (
      <>
        {/* 
        {needReset &&
        <Alert type='info'>
          {t.Tunnel_Reset_password_too_old_1} <br /> {t.Tunnel_Reset_password_too_old_2}
        </Alert>
        }
        {inTunnel &&
          <Alert type='info'>
            {t.Tunnel_Reset_password_first_login_message_1} <br /> {t.Tunnel_Reset_password_first_login_message_2}
          </Alert>
        }
        */}
        <Alert type='info'>
          {t.Tunnel_Reset_password_too_old_1} <br /> {t.Tunnel_Reset_password_too_old_2}
        </Alert>
        <div className={classes.helpContainer}>
          <span>{t.Page_Reset_password_conditions_help}</span>
          <div className={classes.labelsContainer}>
            <LabelValidation
              label={t.Page_Reset_password_conditions_help_first}
              isValid={this.isLengthValid()}
            />

            <LabelValidation
              label={t.Page_Reset_password_conditions_help_fourth}
              isValid={this.hasNumber()}
            />

            <LabelValidation
              label={t.Page_Reset_password_conditions_help_second}
              isValid={this.notIdenticalChars()}
            />

            <LabelValidation
              label={t.Page_Reset_password_conditions_help_third}
              isValid={this.noMoreThan3reps()}
            />
          </div>
        </div>

        <form onSubmit={this.props.handleSubmit}>
          {(!needReset && !inTunnel) &&
          <Grid container>
            <Grid item xs={12}>
              <Field
                name="old_password"
                component={TextField}
                label={t.Page_Reset_password_old_label}
                fullWidth={true}
                type='password'
              />
            </Grid>
          </Grid>
          }
          <Grid container>
            <Grid item xs={12}>
              <Field
                name="new_password"
                component={TextField}
                label={t.Page_Reset_password_label}
                fullWidth={true}
                type='password'
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Field
                name="password_confirm"
                component={TextField}
                label={t.Page_Reset_password_confirm_label}
                fullWidth={true}
                type='password'
              />
            </Grid>
          </Grid>

          {inTunnel &&
          <Actions
            {...this.props}
            onClick={this.submit}
            canNext={valid}
          />
          }

          {!inTunnel &&
            <div style={{marginTop: 16, display: 'flex', justifyContent: 'flex-end'}}>
              <Btn
                color='primary'
                variant='contained'
                onClick={this.submit}
                disabled={!valid}
                loading={isUpdating}
              >{t.save}</Btn>
            </div>
          }

        </form>
      </>
    )
  }

  @autobind
  private submit(){
    this.props.submitForm();
  }

  @autobind
  private isLengthValid(){
    const { password } = this.props;
    return !!(password && password.length <= 16 && password.length >= 10);
  }

  @autobind
  private hasNumber(){
    const { password } = this.props;
    return !!(password && /\d/.test(password));
  }

  @autobind
  private notIdenticalChars(){
    const { password } = this.props;
    return !!(password && new RegExp('.*^((.)\\2?(?!\\2))+$').test(password))
  }

  @autobind
  private noMoreThan3reps(){
    const { password } = this.props;
    let isValid: boolean = true;

    if(!password) {
      isValid = false;
    } else {
      for(let i=0;i< password.length;i++){
        const char = password.charAt(i);
        if(password.split('').filter(x => x === char).length > 3){
          isValid = false;
        }
      }
    }
    return isValid;
  }

}

const selector = formValueSelector('newPasswordForm');

const state2props = (state: RootState) => ({
  isFetching: state.accountInfo.isFetching,
  connectedUser: state.accountInfo.connectedUser,
  isUpdating: state.accountInfo.isUpdating,
  password: selector(state, 'new_password')
});

const dispatch2props = dispatch => ({
  submitForm:() =>  dispatch(submit('newPasswordForm'))
});

export default compose(
  withI18n,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(reduxForm({
  form: 'newPasswordForm',
  validate
})(PasswordTunnel));



// WEBPACK FOOTER //
// ./src/page/ValidationTunnel/PasswordTunnel.tsx